import React, { Component } from 'react'
import {throttle} from 'lodash'
import {SlideshowStyle} from './../styles'
import {Arrow} from './'
import Flickity from 'flickity'

export default class SlideshowMobile extends Component {

  state = {
    activeSlider: false,
    cardLength: 0,
    next: false,
    prev: false,
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize.bind(this))
  }

  componentWillReceiveProps({children, isHome, ready}){
    if (children !== this.props.children && ready && ready !== this.props.ready) {
      this.timer = setTimeout(() => {
        if(this.slider) this.init()
      }, 300)
    }
  }

  init() {
    window.addEventListener('resize', this.onResize.bind(this))

    this.cards = this.slider.querySelectorAll('.card-inner')

    this.setState({
      cardLength: this.cards ? this.cards[0].offsetWidth * this.cards.length : 0
    }, () => {
      this.isSlider()
    })
  }

  initSlider = () => {
    this.flktySlides = new Flickity( this.slider, {
      lazyLoad: 1,
      pageDots: false,
      prevNextButtons: false,
      contain: true,
      on: {
        'ready': () => {
          this.setState({
            next: this.cards.length > 1,
          })
        },
        'change': (index) => {
          this.setState({
            prev: index > 0,
            next: index < this.cards.length - 1,
          })
        },
      }
    })
  }

  onResize = throttle(() => {
    this.isSlider()
  }, 400)

  isSlider = () => {
    if (this.state.cardLength > 0 && this.slider) {
      this.setState({ 
        activeSlider: this.state.cardLength > this.slider.offsetWidth, 
      }, () => {
        if ( (!this.flktySlides || !this.flktySlides.isActive) && this.state.activeSlider) this.initSlider()
        if (this.flktySlides && !this.state.activeSlider) this.flktySlides.destroy()
      })
    }
  }

  next = (e) => {
    e.preventDefault()
    this.flktySlides.next()
  }

  prev = (e) => {
    e.preventDefault()
    this.flktySlides.previous()
  }

  render () {
    const { children } = this.props
    const { activeSlider, prev, next } = this.state
    return (
      <div className={` slideshow-article ${SlideshowStyle(prev, next)}`}>
      {
        activeSlider && (
          <div className='slideshow-article-nav'>
            <button className="slideshow-nav-prev prev" onClick={this.prev}>
              <Arrow width={24} height={24} />
            </button>
            <button className="slideshow-nav-next next" onClick={this.next}>
              <Arrow width={24} height={24} />
            </button>
          </div>
        )
      }
        <div className='slideshow-article-container flex' ref={ (slider) => this.slider = slider }>
          {
            children
          }
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SlideshowMobile.js